import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ListComponent, ConfigurationState, UserGroup, UserGroupRepositoryService } from 'reg-hub-common';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-user-groups-list',
    templateUrl: './user-groups-list.component.html',
    styleUrls: ['./user-groups-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserGroupsListComponent extends ListComponent<UserGroup> implements OnInit {
  private readonly transloco = inject(TranslocoService);
    hasUserManagementAccess: boolean | null = null;
    displayedColumns: string[] = ['name',
        'address',
        'billingCentre',
        'configuration'];

    constructor(repo: UserGroupRepositoryService,
        private router: Router,
        private messageService: ToastrService,
        private configurationState: ConfigurationState) {
        super(repo);
    }

    ngOnInit(): void {
        this.configurationState.hasUserManagementAccess().then(hasAccess => {
            if (hasAccess) {
                // Only show active user groups to the client
                this.repo.getFirstPage(new HttpParams().set('IsActive', true));
            }
            else {
                this.messageService.error(this.transloco.translate('management.accessDenied'));
            }
        });
    }

    navigateToAddUserGroup() {
        this.router.navigate(['management', 'userGroups', 'add']);
    }
}